import io from 'socket.io-client';
import { CONFIG } from '../config/general';
const socket = io.connect(
  CONFIG.REACT_APP_ENDPOINT,
  {
    transports: ['websocket'],
    reconnection: true,      
    reconnectionAttempts: Infinity, 
    reconnectionDelay: 1000,        
    reconnectionDelayMax: 5000,    
    randomizationFactor: 0.5
  }
);

export default socket;